export { default } from "./StockEnquiry";
